import { useEffect } from "react"
import { isMobile } from "../Hero";
function SideNav({items}){
    const changeCrypto = (name) => {
        const foundCrypto = items.find(x => x.item === name);
        console.log("found crypto ",foundCrypto)
        if(foundCrypto.item === 'Ethereum'){
            console.log("etereum found")
            foundCrypto.link("ethereum");
            sessionStorage.setItem("crypto", "ethereum");
        }
        else if(foundCrypto.item === 'Bitcoin'){
            foundCrypto.link(name);
            sessionStorage.setItem("crypto", "bitcoin");
        }
        else if(foundCrypto.item === 'Tron'){
            foundCrypto.link(name);
            sessionStorage.setItem("crypto", "tron");
        }
        else if(foundCrypto.item === 'BNB'){
             console.log("found crypto bnb ",foundCrypto)
            foundCrypto.link(name);
            sessionStorage.setItem("crypto", "bnb");
        }        
        else if(foundCrypto.item === 'OKB'){
             console.log("found crypto bnb ",foundCrypto)
            foundCrypto.link(name);
            sessionStorage.setItem("crypto", "okb");
        }               
    }
    useEffect(()=>{

    },[])
    return(
    <div id="mySidebar" style={{zIndex:100}}class="sidenav">
    <a style={{paddingBottom:"10px"}}href="/trade" class="closebtn" onclick="closeNav()">&times;</a>
    <div style={{paddingTop:"50px"}}></div>
    {items.map((x) => {
       return <a style={{fontSize :isMobile()? "12px": "25px"}} href={'/trade'} onClick={()=>changeCrypto(x.item)}>{x.item}</a>
    })}
   </div>

    )
} 

export default SideNav